'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var google_map = {};

exports.__exports = google_map;
